var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorkIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "538.000000pt",
    height: "477.000000pt",
    viewBox: "0 0 538.000000 477.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,477.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2204 4609 c-65 -19 -127 -71 -159 -133 l-30 -60 -3 -248 -4 -248 -823 0 c-799 0 -826 -1 -878 -20 -57 -21 -103 -63 -133 -120 -18 -33 -19 -70 -22 -527 l-3 -493 1048 0 1048 0 0 69 c1 79 15 113 61 141 30 19 51 20 404 20 353 0 374 -1 404 -20 45 -27 59 -59 60 -139 l1 -71 1048 0 1048 0 -3 493 -3 492 -25 45 c-29 52 -95 105 -148 120 -24 6 -324 10 -859 10 l-821 0 -4 248 -3 247 -28 58 c-32 64 -72 99 -147 128 -47 18 -79 19 -523 18 -259 0 -486 -5 -503 -10z m986 -454 l0 -235 -470 0 -470 0 0 235 0 235 470 0 470 0 0 -235z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2480 2525 l0 -235 230 0 230 0 0 235 0 235 -230 0 -230 0 0 -235z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152 1453 l3 -1078 22 -42 c29 -54 86 -100 147 -118 75 -23 4697 -23 4772 0 61 18 118 64 147 118 l22 42 3 1078 2 1077 -1043 0 -1044 0 -6 -122 c-4 -66 -7 -152 -7 -191 0 -80 -18 -119 -66 -142 -48 -22 -740 -22 -788 0 -39 19 -65 60 -66 106 0 19 -3 105 -7 192 l-5 157 -1044 0 -1044 0 2 -1077z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkIcon);
export default __webpack_public_path__ + "static/media/work_icon.959e42ad12849ec3f9acc36a1ed9e96e.svg";
export { ForwardRef as ReactComponent };